import { client } from "../../api/client.ts";
import { useCanQueryTenantData, useInstallWorkspaceHeader } from "@sg-protect/shell";
import { useBulkOperationLists, useRemediationBulkSummariesQuery } from "../remediation/BulkProvider.tsx";
import { ActivityPill } from "./ActivityPill.tsx";

// Rendered in the header, which sits above every module provider: read none of them, fetch the bulk data here.
export function ActivityHeaderWidget() {
    const isWorkspaceScoped = useInstallWorkspaceHeader(client);
    const canQueryTenantData = useCanQueryTenantData();

    const canQueryBulkOperations = isWorkspaceScoped && canQueryTenantData;

    const { runningOperations, failedOperations } = useBulkOperationLists(canQueryBulkOperations);
    const summaries = useRemediationBulkSummariesQuery(runningOperations.map(operation => operation.bulkId));

    return (
        <ActivityPill runningOperations={runningOperations} failedOperations={failedOperations} summaries={summaries} />
    );
}
